import apiHelpers from '@/utils/api'
import { AxiosPromise } from 'axios'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AloDbCoverageIteration } from '@/models/alodb/AloDbCoverageIteration'
import { AloBaseArray } from '@/models/alo/AloBaseArray'
import { ISmartAllResultCoverage } from '@/models/iris/smartMission/ISmartAllResultCoverage'
import { arrayToDataScienceArr } from '@/models/alo/AloMission'



export default {  
  getCoverageIterations(): AxiosPromise<AlrContainer<AloBaseArray<AloDbCoverageIteration>>> {    
    return apiHelpers.apiCall({ 
      url: 'api/admin/coverage', 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return new AlrContainer<AloBaseArray<AloDbCoverageIteration>>(JSON.parse(data),AloDbCoverageIteration.createAloDbCoverageIterationArray)
      }]
    })
  },
  getCoverageIteration(id:number):AxiosPromise<AlrContainer<AloDbCoverageIteration>> {
    return  apiHelpers.apiCall({ 
      url: `api/admin/coverage/${id}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return new AlrContainer<AloDbCoverageIteration>(JSON.parse(data),AloDbCoverageIteration.createAloDbCoverageIterationWithDetail)
      }]
    })
  },
  saveCoverageIteration(cov:AloDbCoverageIteration):AxiosPromise<AlrContainer<AloDbCoverageIteration>> {
    if(cov.COV_ID && cov.COV_ID > 0) {
      return  apiHelpers.apiCall({ 
        url: `api/admin/coverage/${cov.COV_ID}`, 
        method: 'PUT',
        data: cov,
        transformResponse: [function (data:string) {          
          return new AlrContainer<AloDbCoverageIteration>(JSON.parse(data),AloDbCoverageIteration.createAloDbCoverageIterationWithDetail)
        }]
      })    
    }
    else{
      return  apiHelpers.apiCall({ 
        url: `api/admin/coverage`, 
        method: 'POST',
        data: cov,
        transformResponse: [function (data:string) {          
          return new AlrContainer<AloDbCoverageIteration>(JSON.parse(data),AloDbCoverageIteration.createAloDbCoverageIterationWithDetail)
        }]
      })    
    }    
  },
  getCoverageResult(id:number) {
    return  apiHelpers.apiCall({ 
      url: `/api/iris/irisRequestingCoverageResult/${id}`, 
      method: 'GET',      
      transformResponse: [function (data:string) {          
        return new AlrContainer<ISmartAllResultCoverage>(JSON.parse(data),(data)=>data)
      }]
    })    
  },
  getFormationResult(id:number) {
    return  apiHelpers.apiCall({ 
      url: `/api/iris/IrisRequestingFormationResult/${id}`, 
      method: 'GET',      
      transformResponse: [function (data:string) {          
        return new AlrContainer<ISmartAllResultCoverage>(JSON.parse(data),(data)=>data)
      }]
    })    
  },
  deleteCoverageIteration(id:number):AxiosPromise<AlrContainer<AloDbCoverageIteration>> {
    return  apiHelpers.apiCall({ 
      url: `api/admin/coverage/${id}`, 
      method: 'DELETE',
      transformResponse: [function (data:string) {          
        return new AlrContainer<any>(JSON.parse(data),i => i)
      }]
    })    
  },
  getDataScience(id:number,gliderKey:string,targetYosCycles:Array<number>|null) {
    return  apiHelpers.apiCall({ 
      url: `/api/mesurevirtualcov/${id}/${gliderKey}`, 
      method: 'GET',
      params: {targetYosCycles:targetYosCycles && targetYosCycles.length<=20?targetYosCycles.join(','):null},
      transformResponse: [function (data:string) {          
        return new AlrContainer<Array<any>>(JSON.parse(data),arrayToDataScienceArr)
      }]
    })    
  }
}